module.exports = __webpack_public_path__ + "img/11.abe6cad2.webp";